import { render, staticRenderFns } from "./setBase.vue?vue&type=template&id=178e5cac&scoped=true"
import script from "./setBase.vue?vue&type=script&lang=js"
export * from "./setBase.vue?vue&type=script&lang=js"
import style0 from "./setBase.vue?vue&type=style&index=0&id=178e5cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178e5cac",
  null
  
)

export default component.exports